import { marked } from 'marked';

marked.use({ breaks: true });

/** Parse CMS markdown/plain-text to safe HTML. Single Enter = <br>, double Enter = new paragraph. */
export function parseMarkdown(text: string | null | undefined): string {
  if (!text) return '';
  return marked.parse(text) as string;
}
